import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebUserInfo } from '../data/web-user-info';

@Injectable({
  providedIn: 'root'
})
export class ContactService {


constructor(private http: HttpClient) { }

  saveWebUserInfo(url: string, webUserInfo: WebUserInfo) {
    return this.http.post<any>(url, webUserInfo);
  }

  getVisitorCount(api: string, type: string) {
    return this.http.get(api + "/" + type, {
      responseType: "json",
    });
  }
}
